import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Providers } from 'providers/Providers';
import { Header } from 'components/Header/Header';
import { Footer } from 'components/Footer/Footer';
import { TransferPage } from 'pages/TransferPage/TransferPage';
import { ErrorPage } from 'pages/ErrorPage/ErrorPage';
import { MaintenanceBanner } from 'components/MaintenanceBanner/MaintenanceBanner';
const App = () => (_jsx(Router, { children: _jsx("div", { className: "wrapper", children: _jsxs(Providers, { children: [_jsx(Header, {}), _jsxs("div", { className: "content-wrapper", children: [_jsx(MaintenanceBanner, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(TransferPage, {}) }), _jsx(Route, { path: "*", element: _jsx(ErrorPage, {}) })] })] }), _jsx(Footer, {})] }) }) }));
export default App;
